import React from "react";
import Modal from "react-bootstrap/Modal";

import tickMark from "../images/tickMark.jpg";
export default function DocModal(props) {
  const handleClose = () => props.setShow(false);
  return (
    <div>
      <Modal
        show={props.show}
        onHide={handleClose}
        style={{
          top: "20%",
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Added to cart</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parentProfileUpdatedDiv">
         
            <img src={tickMark}  alt="document" className="glizmedLogoProfileUpdateModal"/ > <br /><br />
            {/* <button className="updatedProfileBtn" onClick={()=> {props.navigate("/home/dashboard")}}> OK </button> */}
         
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
